import { PaletteMode, Components, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';
import { typographyTokens } from '../typography-tokens';

export const MuiFormLabelTheme = (mode: PaletteMode): Components<Theme>['MuiFormLabel'] => {
  const { componentTokens } = themePalette(mode);

  return {
    styleOverrides: {
      root: {
        // Label styling - matching pounce medium (0.875rem / 14px) with medium weight (500)
        fontSize: typographyTokens.fontSizes.sm,
        fontWeight: typographyTokens.fontWeights.medium,
        color: componentTokens.inputs.colors.normal.text.inputText.resting,
        transition:
          'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
        '&:not(.Mui-disabled):hover': {
          color: componentTokens.inputs.colors.normal.text.inputText.resting,
        },
        '&.Mui-disabled': {
          opacity: 0.4,
          cursor: 'not-allowed',
        },
        '&.MuiInputLabel-root': {
          transform: 'translate(14px, 14px) scale(1)',
        },
        '&.MuiInputLabel-shrink': {
          // Adjust the label position when it moves to the top
          transform: 'translate(14px, 8px) scale(0.65)',
          backgroundColor: 'transparent',
          color: componentTokens.inputs.colors.normal.text.label.resting,
          fontWeight: typographyTokens.fontWeights.semibold,
        },
        '&.Mui-focused': {
          color: componentTokens.inputs.colors.normal.text.inputText.selected,
        },
      },
    },
  };
};

export const MuiFormControlTheme = (): Components<Theme>['MuiFormControl'] => {
  return {
    styleOverrides: {
      root: {
        // Create stacking context to contain floating labels
        // This prevents labels from appearing above dropdown menus
        position: 'relative',
        zIndex: 0,
        // Apply extra top padding and minHeight to inputs when a label is present
        // This makes room for the floating label above the input value
        '&:has(.MuiInputLabel-root) .MuiSelect-root .MuiOutlinedInput-input': {
          padding: '21.5px 56px 7px 14px',
          minHeight: 'inherit',
        },
        '&:has(.MuiInputLabel-root) .MuiOutlinedInput-input': {
          padding: '21px 14px 9px',
          minHeight: 'inherit',
        },
        '&:has(.MuiInputLabel-root) .MuiInputBase-multiline': {
          padding: '21px 14px 9px',
          minHeight: 'inherit',
        },
        '&:has(.MuiInputLabel-root) .MuiAutocomplete-inputRoot': {
          padding: '21.5px 56px 7px 14px',
          minHeight: 'inherit',
        },
        // When there's no label, adjustments for proper vertical centering
        '&:not(:has(.MuiInputLabel-root)) .MuiSelect-select.MuiSelect-select': {
          minHeight: 'inherit',
        },
        '&:not(:has(.MuiInputLabel-root)) .MuiOutlinedInput-notchedOutline': {
          top: '-9px',
        },
      },
    },
  };
};
